import { render } from "./viewDetailModal.vue?vue&type=template&id=167fdb66&scoped=true"
import script from "./viewDetailModal.vue?vue&type=script&lang=js"
export * from "./viewDetailModal.vue?vue&type=script&lang=js"

import "./viewDetailModal.vue?vue&type=style&index=0&id=167fdb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167fdb66"]])

export default __exports__